import { Component, inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
  standalone: false
})
export class NavbarComponent implements OnInit {
  public menuToggled = false;
  public authServices = inject(AuthService);
  private router = inject(Router);

  public dataUsuario: any;


  constructor() { }

  ngOnInit() {
    this.obtenerInformacionLocal();
  }


  toggleMenu(event: Event) {
    event.preventDefault();
    this.menuToggled = !this.menuToggled;
  }

  obtenerInformacionLocal(){
    this.dataUsuario = JSON.parse(localStorage.getItem("usuario_data") || null);
  }

}
